// TODO: Remove checkmark that shows if a game is playable

import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import styles from './ContentCard.scss';
import Button from 'Components/Button';
import GradeRangeSquare from 'Components/GradeRangeSquare';
import VideoPlayIcon from './video-play-icon.svg';
import { US_ONLY_BOOKS } from 'Constants/USOnlyBooks';
import { CountryContext } from 'Containers/App';

class ContentCard extends Component {
  render() {
    const props = this.props;
    const { slug, index } = props;

    const sponsoredClass = props.sponsoredBy ? ' ContentCard2--sponsored' : '';
    // const adInjectClass = index % 3 !== 0 ? ' ContentCard' : '';
    const adInjectClass = ' ContentCard';

    return (
      <CountryContext.Consumer>
        {countryCode =>
          !(US_ONLY_BOOKS.includes(slug) && countryCode !== 'US') && (
            <div
              className={'ContentCard2' + sponsoredClass + adInjectClass}
              data-type={props.type}
              data-index={index}
            >
              {props.externalLink ? (
                <div>
                  <a href={props.externalLink} target="_blank">
                    <ContentCardContents {...props} />
                  </a>
                  <div className="ContentCard2__ButtonContainer">
                    <Button
                      externalLink={getLinkPath({ ...props })}
                      text={getButtonLabel(props)}
                      mediaType={props.type}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <Link to={getLinkPath({ ...props })}>
                    <ContentCardContents {...props} />
                  </Link>
                  <div className="ContentCard2__ButtonContainer">
                    <Button
                      to={getLinkPath({ ...props })}
                      text={getButtonLabel(props)}
                      mediaType={props.type}
                    />
                  </div>
                </div>
              )}
            </div>
          )
        }
      </CountryContext.Consumer>
    );
  }
}

const ContentCardContents = props => (
  <div className="ContentCard2__link-container">
    {props.sponsoredBy ? (
      <div className="ContentCard2__sponsored-by">
        Sponsored by {props.sponsoredBy}
      </div>
    ) : null}
    <div className="ContentCard2__image-canvas">
      {props.type === 'video' ? (
        <VideoPlayIcon className="ContentCard2__video-play" />
      ) : null}
      <img
        className="ContentCard2__image"
        alt={`${props.title} -- Thumbnail`}
        src={props.smallImageURI ? props.smallImageURI : props.imageURI}
      />
    </div>
    <GradeRangeSquare {...props} />
    {props.seriesTitle && !props.sponsoredBy ? (
      <div className="ContentCard2__series-title">{props.seriesTitle}</div>
    ) : null}
    <div className="ContentCard2__title">{truncateTitle(props)}</div>
  </div>
);

const getLinkPath = ({ type, slug, series, externalLink }) => {
  if (externalLink) return externalLink;
  const seriesPart = series ? `/${series}` : '';
  if (type === 'series') return `/videos/${slug}`;
  return `/${pluralize[type]}${seriesPart}/${slug}`;
};

const pluralize = {
  game: 'games',
  video: 'videos',
  series: 'series',
  book: 'books',
};

const getButtonLabel = ({ type }) => {
  switch (type) {
    case 'game':
      return 'Play';
    case 'book':
      return 'Read';
    case 'video':
    case 'series':
      return 'Watch';
    case 'printable':
      return 'View';
    default:
      return 'Go';
  }
};

const truncateTitle = ({ title, partOfSeries }) => {
  const cutoff = partOfSeries ? 40 : 48;
  const stringPos = cutoff - 3;
  return title.length > cutoff
    ? title.substring(0, stringPos) + '\u2026'
    : title;
};

export default ContentCard;
